import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { dataTableInjectionKey as f } from "../interface.js";
import { off as i, on as r } from "../../../../../../../evtd@0.2.4/node_modules/evtd/es/delegate.js";
import { defineComponent as v, inject as w, onBeforeUnmount as z, h as R } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as h } from "../../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const x = v({
  name: "ColumnResizeButton",
  props: {
    onResizeStart: Function,
    onResize: Function,
    onResizeEnd: Function
  },
  setup(o) {
    const {
      mergedClsPrefixRef: d
    } = w(f), t = h(!1);
    let s = 0;
    function l(e) {
      return e.clientX;
    }
    function m(e) {
      var n;
      e.preventDefault();
      const c = t.value;
      s = l(e), t.value = !0, c || (r("mousemove", window, a), r("mouseup", window, u), (n = o.onResizeStart) === null || n === void 0 || n.call(o));
    }
    function a(e) {
      var n;
      (n = o.onResize) === null || n === void 0 || n.call(o, l(e) - s);
    }
    function u() {
      var e;
      t.value = !1, (e = o.onResizeEnd) === null || e === void 0 || e.call(o), i("mousemove", window, a), i("mouseup", window, u);
    }
    return z(() => {
      i("mousemove", window, a), i("mouseup", window, u);
    }), {
      mergedClsPrefix: d,
      active: t,
      handleMousedown: m
    };
  },
  render() {
    const {
      mergedClsPrefix: o
    } = this;
    return R("span", {
      "data-data-table-resizable": !0,
      class: [`${o}-data-table-resize-button`, this.active && `${o}-data-table-resize-button--active`],
      onMousedown: this.handleMousedown
    });
  }
});
export {
  x as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/data-table/src/HeaderButton/ResizeButton.js
// module id = 1649
// module chunks = 67